import { render } from "./RegistrationComplete.vue?vue&type=template&id=e2cde9aa"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__